module.exports = __webpack_public_path__ + "img/revista-madrigal-03.eb503dce.jpg";